import type { PropsWithChildren } from 'react';

import { BudgetCategoryCardAttributes } from './components/BudgetCategoryCardAttributes'
import { BudgetCategoryCardDetailsBreakdown } from './components/BudgetCategoryCardDetailsBreakdown'
import { BudgetCategoryCardEmptyState } from './components/BudgetCategoryCardEmptyState'
import { BudgetCategoryCardGranularSpend } from './components/BudgetCategoryCardGranularSpend'
import { BudgetCategoryCardHeader } from './components/BudgetCategoryCardHeader'
import { BudgetCategoryCardProgressBar } from './components/BudgetCategoryCardProgressBar'
import { BudgetCategoryCardSubtotal } from './components/BudgetCategoryCardSubtotal'
import { BudgetCategoryCardSubtotals } from './components/BudgetCategoryCardSubtotals'
import { BudgetCategoryCardStyled } from './styles/BudgetCategoryCardStyled'

export interface IBudgetCategoryCardProps {}

// TODO: refactor to use Box component to match mock-ups
export const BudgetCategoryCard = ({
  children,
}: PropsWithChildren<IBudgetCategoryCardProps>) => {
  return <BudgetCategoryCardStyled>{children}</BudgetCategoryCardStyled>
}

BudgetCategoryCard.displayName = 'BudgetCategoryCard'

BudgetCategoryCard.Header = BudgetCategoryCardHeader
BudgetCategoryCard.DetailsBreakdown = BudgetCategoryCardDetailsBreakdown
BudgetCategoryCard.Subtotals = BudgetCategoryCardSubtotals
BudgetCategoryCard.Subtotal = BudgetCategoryCardSubtotal
BudgetCategoryCard.ProgressBar = BudgetCategoryCardProgressBar
BudgetCategoryCard.Attributes = BudgetCategoryCardAttributes
BudgetCategoryCard.GranularSpend = BudgetCategoryCardGranularSpend
BudgetCategoryCard.EmptyState = BudgetCategoryCardEmptyState
